import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './Notifications.frontend.types'

@Injectable({ providedIn: 'root' })
export class Notifications_alerts_send_testService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { to?: string }): Promise<{ success?: boolean, messages?: any[] }> 
  {
    let url = `${environment.backendUrl}api/Notifications/functions/alerts_send_test`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }

}

